var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.0001H0.00439446C0.00439446 19.1446 1.6821 22.8943 4.39397 25.6062C7.10584 28.3179 10.8555 29.9956 14.9995 29.9956V30H14.9998H15V29.9956C19.144 29.9956 22.8942 28.3179 25.606 25.606C28.3179 22.8941 29.9956 19.1444 29.9956 15.0004H30V15.0001V14.9999H29.9956C29.9956 10.8556 28.3177 7.1059 25.606 4.39376C22.8939 1.68211 19.1447 0.00439449 15.0005 0.00439449V0H15V0.00439449C10.8558 0.00439449 7.10584 1.68211 4.39397 4.39401C1.6821 7.1059 0.00439446 10.8556 0.00439446 14.9996H0V15.0001ZM10.3709 17.5047C9.89193 17.9706 9.12558 17.9601 8.65977 17.4808C8.19371 17.0018 8.20446 16.2355 8.68345 15.7696L14.1817 10.4379L15.0254 11.3053L14.1807 10.434C14.6619 9.96745 15.4299 9.97941 15.8967 10.4604C15.9101 10.4745 15.9233 10.4884 15.9358 10.5031L21.3205 15.7699C21.7997 16.2357 21.8102 17.0021 21.3444 17.4811C20.8786 17.9603 20.1122 17.9708 19.633 17.505L15.0217 12.9948L10.3709 17.5047Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTop);
export default __webpack_public_path__ + "static/media/icon-top.a96f97fe01c2578071a52c9b24d77781.svg";
export { ForwardRef as ReactComponent };